//sample data
const cleanData = {
    leftSide: {
        photo: '',
        phone: '',
        email: '',
        address: '',
        websites: [
            {
                order: 1,
                id: 1,
                label: '',
                url: ''
            }
        ],
        sections: [
            {
                order: 1,
                id: 1,
                title: '',
                rows: [
                    {
                        order: 1,
                        id: 1,
                        label: '',
                        link: '',
                    },

                ],
            }
        ],
    },
    rightSide: {
        fullName: 'Your Name',
        jobTitle: 'Your Job Title',
        profileSummary: 'Your Profile Summary',
        sections: [
            {
                order: 1,
                id: 1,
                title: '',
                rows: [
                    {
                        order: 1,
                        id: 1,
                        title: '',
                        subTitle: '',
                        details: [
                            {
                                order: 1,
                                id: 1,
                                detail: ''
                            },
                        ]
                    },
                ],
            }
        ],

    },
    branding: {
        leftBg: "#E2DEDF",
        rightBg: '#FFFFFF',
        fontDark: '#444446',
        fontLight: '#5C5C5D',
        lineSeperator: '#16A3F2',

    }
}

export default cleanData